import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";

import { PDFViewer } from '@react-pdf/renderer';
import PrintDocument from "./printDocument";
import {injectIntl} from "react-intl";
import {convertImgToBase64URL} from "../../../misc/utils";
import {getFabricatorLogo} from "../../../misc/fabricatorHardcode";
import {getCartItemThumbnails} from "../../../actions/printFunctions";

const PrintPopup = (props) => {
  const {fabricatorData, userState, quotes, cartItems, priceWorksheetState, jobId, intl, filterGroups, activeTheme,
    wizardState, visualizersLoaded, sqftSlabState, printState} = props;
  const {userInfo} = userState;

  const logoString = getFabricatorLogo(fabricatorData);
  const [logoBase64, setLogoBase64] = useState("");
  const [cartItemsThumbnails, setCartItemsThumbnails] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const setLogoUrl = async () => {
    const newLogo = await convertImgToBase64URL(logoString);
    if (fabricatorData.settings.showCartItemThumbnailsInReceipt) {
      const cartItemsThumbnailsBase64 = await getCartItemThumbnails(cartItems, wizardState);
      setCartItemsThumbnails(cartItemsThumbnailsBase64);
    }
    setLogoBase64(newLogo);
    setIsLoading(false);
  }

  useEffect(() => {
    if (!visualizersLoaded.length) {
      return
    }
    setLogoUrl()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoaded])

  // if (!userInfo.email) {
  //   console.info("can't render document, try to log in")
  //   return null
  // }

  let employeeSelected = null;
  if (userInfo.employeeId && userState.employeesListReceived) {
    employeeSelected = userState.employeesList.find(emp => +emp.id === +userInfo.employeeId)
  }

  if (isLoading) {
    return null
  }

  return (
    <div className="print">
      <PDFViewer>
        <PrintDocument fabricatorData={fabricatorData}
                       printLogo={logoBase64}
                       userInfo={userInfo}
                       quotes={quotes}
                       jobId={jobId}
                       priceWorksheetState={priceWorksheetState}
                       assignQuotePopupCustomer={null}
                       employeeSelected={employeeSelected}
                       locale={intl.locale}
                       filterGroups={filterGroups}
                       activeTheme={activeTheme}
                       wizardState={wizardState}
                       cartItemsThumbnails={cartItemsThumbnails}
                       sqftSlabState={sqftSlabState}
                       printState={printState}
                       cartItems={cartItems}/>
      </PDFViewer>
    </div>
  )
}

PrintPopup.propTypes = {

};


const mapStateToProps = (store) => {
  const {visualizersLoaded, jobId, activeTheme} = store.serverState;
  return {
    cartItems: store.cartState.cartItems,
    sqftSlabState: store.sqftSlabState,
    fabricatorData: store.fabricatorState,
    userState: store.userState,
    quotes: store.quotesState.quotes,
    priceWorksheetState: store.priceWorksheetState,
    jobId,
    filterGroups: store.filterState.filterGroups,
    activeTheme,
    visualizersLoaded,
    wizardState: store.wizardState,
    printState: store.printState,
  };
};

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(PrintPopup)
);
